var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Books")]), _vm._v(" "), _c('p', [_vm._v("Add books to your collection.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Book info:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book),
      expression: "book"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "In Search of Lost Time, Hamlet, To Kill a Mockingbird"
    },
    domProps: {
      "value": (_vm.book)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.findBook($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.book = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.book.length < 3
    },
    on: {
      "click": _vm.findBook
    }
  }, [_vm._v("Find")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success),
      expression: "success"
    }],
    staticClass: "alert alert-dismissible alert-success"
  }, [_c('strong', [_vm._v("Success!")]), _vm._v(" Book added to your collection.\n  ")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "progress progress-striped active"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Searching for books...")])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.books && _vm.books.length > 0) ? _c('p', [_vm._v("Please choose a book from below results:")]) : _c('p', [_vm._v("You can search a book either by title or author name.")])]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return (book.volumeInfo.imageLinks) ? _c('div', {
      key: book.id,
      staticClass: "col-md-2 col-sm-3 col-xs-6"
    }, [_c('div', {
      staticClass: "book"
    }, [_c('div', {
      staticClass: "controls"
    }, [_c('i', {
      staticClass: "fa fa-plus text-success",
      attrs: {
        "aria-hidden": "true",
        "title": "Add"
      },
      on: {
        "click": function($event) {
          _vm.addBook(book)
        }
      }
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "thumbnail",
        "title": book.volumeInfo.title,
        "src": book.volumeInfo.imageLinks.thumbnail
      }
    })])]) : _vm._e()
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cb18066","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/books-add.vue
// module id = 91
// module chunks = 0